import styled from 'styled-components';
import { Tabs } from '@material-ui/core';

export const StyledTabs = styled(Tabs)`
  border-bottom: 1px solid #e5e5e5;
  width: 100%;
`;
